/**
 * Recipe index — promote a grid card's recipe into the Cocktail recipes
 * section above it.
 *
 * A Shopify section cannot read another section's blocks, so the two sides are
 * linked by a shared `recipe_key`: the grid card carries it on
 * `[data-recipe-open]`, the matching rail card on `[data-recipe-key]`.
 *
 * The swap itself is not reimplemented here. `cocktail-recipes.js` already owns
 * it (featured swap + scroll + rail highlight), exposed through the rail card's
 * own select button — so this just forwards the click to that button and lets
 * the existing code run. Nothing in cocktail-recipes.js changes.
 *
 * A card whose key matches nothing is left inert rather than becoming a dead
 * click target: the merchant sees a card that does not respond, not one that
 * responds by doing nothing.
 */
(function () {
  if (typeof document === 'undefined') return;

  var findRail = function (key) {
    return document.querySelector('.lounge__rail-card[data-recipe-key="' + CSS.escape(key) + '"]');
  };

  /* cocktail-recipes.js's activate() returns early when the recipe is already
     featured, which would leave the default card looking dead. Scroll to it
     here instead, matching what that early return skips. */
  var scrollToFeatured = function (rail) {
    var featured = document.querySelector('.lounge__card[data-recipe-id="' + CSS.escape(rail.dataset.recipeId) + '"]');
    if (!featured) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    featured.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };

  var initIndex = function (section) {
    if (section.dataset.recipeIndexBound === '1') return;
    section.dataset.recipeIndexBound = '1';

    section.querySelectorAll('[data-recipe-open]').forEach(function (card) {
      var key = card.dataset.recipeOpen.trim();
      if (!key) return;

      card.addEventListener('click', function () {
        /* Resolved at click time, not bind time: the rail is rendered by another
           section, which the theme editor can reload independently of this one. */
        var rail = findRail(key);
        if (!rail) return;

        if (rail.classList.contains('is-active')) {
          scrollToFeatured(rail);
          return;
        }

        var select = rail.querySelector('[data-cocktail-rail-select]');
        if (select) select.click();
      });
    });
  };

  var initAll = function () {
    document.querySelectorAll('.recipe-index').forEach(initIndex);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.recipe-index').forEach(initIndex);
  });
})();
